import { ApolloClient, HttpLink, ApolloLink, InMemoryCache, from, fromPromise } from '@apollo/client'
import get from 'lodash/get'
import { onError } from '@apollo/client/link/error'
import { BACKEND_URL, AUTH_REFRESH_TOKEN, PERSIST_MODE } from '../constants'
import { useAuthorization } from '../services/authorization'
import { REFRESH_TOKEN } from '../network/auth/queries'

// eslint-disable-next-line react-hooks/rules-of-hooks
const [getAuthToken, setAuthTokens, , clearAuthTokens] = useAuthorization()

const httpLink = new HttpLink({ uri: BACKEND_URL })

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      auth: getAuthToken() || '',
      'client-version': 'coordinator/0.0.0'
    }
  })

  return forward(operation)
})

const errorHandler = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors) {
    const isAuthorizedError = graphQLErrors.some(graphQLError => graphQLError.code === 'authentication-failed')

    if (isAuthorizedError) {
      const refreshToken = sessionStorage.getItem(AUTH_REFRESH_TOKEN) || localStorage.getItem(AUTH_REFRESH_TOKEN)
      const clearAuth = () => {
        clearAuthTokens()
        window.location.href = '/#/login'
      }

      if (!refreshToken) {
        clearAuth()
        return
      }

      return fromPromise(
        client
          .query({
            query: REFRESH_TOKEN,
            variables: {
              refreshToken
            },
            fetchPolicy: 'no-cache'
          })
          .then(response => {
            const dashboardAuthToken = get(response, 'data.security.refreshAuthToken.authenticationResult.accessToken', '')
            const persistMode = localStorage.getItem(PERSIST_MODE)
            setAuthTokens({
              dashboardAuthToken,
              persistMode: +persistMode ? 1 : 0
            })

            return dashboardAuthToken
          })
          .catch(error => clearAuth())
      ).flatMap(accessToken => {
        const oldHeaders = operation.getContext().headers
        // modify the operation context with a new token
        operation.setContext({
          headers: {
            ...oldHeaders,
            auth: accessToken
          }
        })
        // retry the request, returning the new observable
        return forward(operation)
      })
    }
  }
  if (networkError) {
    throw networkError
  }
})

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: from([authMiddleware, errorHandler, httpLink])
})
